import { toast } from '@/hooks/notifications/useToast'

// Check if localStorage is available (e.g., check for private mode)
export const isLocalStorageAvailable = () => {
  try {
    const testKey = '__storage_test__'
    window.localStorage.setItem(testKey, '1')
    window.localStorage.removeItem(testKey)
    return true
  } catch {
    return false
  }
}

// Auth Helpers
export const cleanTokenFromLocalStorage = () => {
  if (typeof window === 'undefined') return
  localStorage.removeItem('user')
}

// Clipboard
export const copyToClipboard = async (text: string) => {
  try {
    if (navigator.clipboard) {
      await navigator.clipboard.writeText(text)
    } else {
      // Fallback for older browsers/contexts
      const textArea = document.createElement('textarea')
      textArea.value = text
      document.body.appendChild(textArea)
      textArea.select()
      document.execCommand('copy')
      document.body.removeChild(textArea)
    }
    toast({ title: 'Copied to clipboard!' })
  } catch (err) {
    console.error('Failed to copy text: ', err)
    toast({ title: 'Failed to copy text', variant: 'error' })
  }
}
